export const sizeColumnMyMemorials: Record<number, string> = {
  0: '120px',
  1: 'auto',
  2: '440px',
  6: '300px',
  7: '300px',
};

export const sizeColumnMyMemorialsTablet: Record<number, string> = {
  0: '120px',
  1: 'auto',
  2: '440px',
  6: '300px',
  7: '300px',
};

export const sizeColumnMyMemorialsMobile: Record<number, string> = {
  0: 'auto',
  1: '170px',
  2: '180px',
  3: 'auto',
};

export const sizeColumnInviteMemorials: Record<number, string> = {
  0: '100px',
  1: '40%',
  2: '40%',
  3: '100px',
  4: '100px',
  5: '100px',
};

export const sizeColumnInviteMemorialsMobile: Record<number, string> = {
  0: 'auto',
  1: '20%',
  2: '20%',
  3: '100px',
  4: '100px',
};
